export enum AdType {
  DirectSale = 100,
  Auction = 200
}
